export const requestMessages = {
  en: {
    backupInvalidDestination: (
      <span>
        Backup volume not found. Please check&nbsp;
        <a
          href='https://docs.ipfabric.io/main/System_Administration/increase_disk_space/#local-backup-disk'
          target='_blank'
          rel='noreferrer'
        >
          Backup and restore in documentation
        </a>
      </span>
    ),
    backupInvalidFTPDestination: '%protocol% connection failed',
    bandwidthHasBeenSet: 'Bandwidth limit has been set to {bandwidth} Mb/s',
    bandwidthHasBeenDisabled: 'Bandwidth limit has been disabled',
    cliAuthenticationAdd: 'The login information inserted',
    cliAuthenticationDel: 'The login information has been deleted',
    cliAuthenticationUpdate: 'Record has been updated',
    invalidLogin: 'Login failed',
    licenseUploaded: 'License is valid',
    messageSent: 'Message has been sent',
    newPasswordSent: 'New password sent',
    passwordReset: 'Password reset',
    saved: 'Saved',
    savedAdvancedDiscovery: 'Discovery settings have been saved',
    restoredAdvancedDiscovery: 'Default settings have been restored',
    restoredSnapshotRetention: 'Snapshot retention settings have been restored',
    savedAdvancedSnapshots: 'Snapshots settings have been saved',
    savedAdvancedSyslog: 'Download options has been stored',
    savedAdvancedCliSettings: 'The settings has been saved',
    savedAdvancedSnmp: 'SNMP settings have been saved',
    savedAdvancedSystemBackup: 'Backup settings has been saved',
    savedAdvancedSystemMaintenance: 'Maintenance settings have been saved',
    settingsAdvancedSystemClearDBSuccess: 'The database has been cleaned',
    seedCopied: 'Seed ip list has been copied to clipboard',
    seedIpClearIps: 'Seed ip list has been cleared',
    seedIpDeleted: 'The IP address has been deleted',
    seedIpSave: 'The list of IP addresses has been saved',
    siteRenamed: 'Site renamed',
    unauthorized: 'Please login',
    unknown: 'Unknown error',
    UPDATE_PASSWORD: "User's password has been updated",
    updated: 'Updated',
    userCreated: 'User created',
    userDeleted: 'User deleted',
    userPasswordUpdate: 'Password updated',
    userPasswordUpdateMakeLogin: 'Password updated, you have to login again',
    userUpdated: 'User updated',
    userSettingsUpdated: 'User settings updated',
    invalidRefreshToken: 'Please sign in, your session expired',
    nimpeeCertificateUploaded: 'IP Fabric certificate uploaded',
    passwordsListUpdated: 'Passwords list updated',
    noDataAvailable: 'No data available',
    reportSaved: 'Report saved',
    reportDeleted: 'Report deleted',
    systemUpdate: 'System Update',
    groupDeleted: 'Group deleted',
    cleanDbScheduled: 'The database clean is scheduled',
    recordAlreadyExist: 'Same record already exist',
    jumphostPublicKeyMissing:
      "The jumphost public key doesn't exists, please contact support",
    issueFound: 'Issue found:',
  },
};
